module.exports = __webpack_public_path__ + "img/alarm.24a3bdd8.png";